import { Product } from "./Product";

export enum ComponentType
{
    // Required part of bundle
    Required,
    // Optional part of bundle
    Optional,
    // Quantity is variable
    Quantity
}

export class ProductComponent implements IProductComponent {
    constructor(component?: IProductComponent, product?: Product) {
        // initialize typed object from generic object
        this._product = product;
        this.productNumber = (component ? component.productNumber : undefined) ?? "";
        this.componentType = (component ? component.componentType : undefined) ?? ComponentType.Required;
        this.unitCode = (component ? component.unitCode : undefined) ?? "";
        this.quantity = (component ? component.quantity : undefined) ?? 1;
    }

    toJSON(): object {
        // return generic object with properties to stringify
        return {
            productNumber: this.productNumber,
            componentType: this.componentType,
            unitCode: this.unitCode,
            quantity: this.quantity
    };
    }

    productNumber: string;
    componentType: ComponentType;
    unitCode: string;
    quantity: number;

    private _product?: Product;

    // Calculated properties

    get product(): Product|undefined {
        return this._product?.products?.find(product => product.productNumber === this.productNumber);
    }
}

export interface IProductComponent {
    productNumber: string;
    componentType?: ComponentType;
    unitCode: string;
    quantity: number;
}